import { VFC } from "react";

import { useGetBrokerContracts } from "../hooks/useGetBrokerContracts";
import BrokerBidsIndexTableView from "../views/BrokerBidsIndexTableView";

const BrokerBidsIndexTableContainer: VFC = () => {
  const { data, isLoading, paginationOptions } = useGetBrokerContracts();

  return (
    <BrokerBidsIndexTableView
      items={data?.data.contracts ?? []}
      paginationOptions={paginationOptions}
      isLoading={isLoading}
    />
  );
};

export default BrokerBidsIndexTableContainer;
